import React from 'react';
import { Container, Icon, Title, Wrapper, Img, Tag } from './style';
import { related } from '../../mock/related'

const Related = () => {
    return (
        <Container>
            <Wrapper main header>
                <Title header>Related Topic</Title>
                <Wrapper icon>
                    <Title>Button</Title>
                    <Icon />
                </Wrapper>
            </Wrapper>

            <Wrapper style>
                {related.map((value) => {
                    return (
                        <Wrapper sections key={value.id}>
                            <Wrapper content >
                                <Img src={value.imgs} />
                                <Tag>{value.tag}</Tag>
                                <Title header>{value.title}</Title>
                                <Wrapper auth>
                                    <Title auth>{value.author}</Title>
                                    <Title auth>{value.date}</Title>
                                </Wrapper>
                            </Wrapper>
                        </Wrapper>
                    )
                })}
            </Wrapper>
        </Container>

    )

}
export default Related